import React from 'react';
import { MediaRow, RowItem } from './media-row';
import { TitleCard } from './title-card';

export function TitleRow({ heading, note, href, titles = [], priority = false, variant = 'poster' }) {
  if (!titles || titles.length === 0) return null;

  return (
    <MediaRow heading={heading} note={note} href={href}>
      {titles.map((title, index) => (
        <RowItem key={title.id || title.Id || index} variant={variant}>
          <TitleCard title={title} priority={priority && index < 3} variant={variant} />
        </RowItem>
      ))}
    </MediaRow>
  );
}

export default TitleRow;
